// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { ActionConfigurationContainer_abstract } from './../abstract/SagaActionLib/ActionConfigurationContainer_abstract';
export class ActionConfigurationContainer extends ActionConfigurationContainer_abstract {}
